import { render, staticRenderFns } from "./WebpartContainer.vue?vue&type=template&id=0af4d428"
import script from "./WebpartContainer.ts?vue&type=script&lang=ts&external"
export * from "./WebpartContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports